import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import check from './check.svg';
import dropdownCaret from './dropdown-caret.svg';
import { MenuItem, Submenu } from '../menu/menu.jsx';
import {
  ACCENT_BLUE,
  ACCENT_MAP,
  ACCENT_PURPLE,
  ACCENT_RED,
  ACCENT_RAINBOW,
  ACCENT_AE,
  Theme,
  ACCENT_COSTOM,
  ACCENT_MIKU,
  ACCENT_CE,
  ACCENT_TY
} from '../../lib/themes/index.js';
import { openAccentMenu, accentMenuOpen, closeSettingsMenu } from '../../reducers/menus.js';
import { setTheme } from '../../reducers/theme.js';
import { persistTheme } from '../../lib/themes/themePersistance.js';
import rainbowIcon from './tw-accent-rainbow.svg';
import customIcon from './tw-accent-custom.svg';
import styles from './settings-menu.css';

import { openCustomTheme } from '../../reducers/modals';

import { closeEditMenu } from '../../reducers/menus';

const options = defineMessages({
  [ACCENT_RED]: {
    defaultMessage: 'Red',
    description: 'Name of the red color scheme, used by TurboWarp by default.',
    id: 'tw.accent.red'
  },
  [ACCENT_PURPLE]: {
    defaultMessage: 'Purple',
    description: 'Name of the purple color scheme. Matches modern Scratch.',
    id: 'tw.accent.purple'
  },
  [ACCENT_BLUE]: {
    defaultMessage: 'Blue',
    description: 'Name of the blue color scheme. Matches Scratch before the high contrast update.',
    id: 'tw.accent.blue'
  },
  [ACCENT_AE]: {
    defaultMessage: 'AstraEditor',
    description: "AstraEditor' theme",
    id: 'tw.accent.ae'
  },
  [ACCENT_CE]: {
    defaultMessage: 'Cyberexplorer Pink',
    description: 'Name of the Cyberexplorer pink',
    id: 'tw.accent.cybere'
  },
  [ACCENT_MIKU]: {
    defaultMessage: 'Miku Green',
    description: 'Name of the Miku color',
    id: 'tw.accent.miku'
  },
  [ACCENT_TY]: {
    defaultMessage: 'Tianyi Blue',
    description: 'Name of the tianyi color',
    id: 'tw.accent.tianyi'
  },
  [ACCENT_RAINBOW]: {
    defaultMessage: 'Rainbow',
    description: 'Name of color scheme that uses a rainbow.',
    id: 'tw.accent.rainbow'
  },
  [ACCENT_COSTOM]: {
    defaultMessage: 'Costom',
    description: 'Costom your theme',
    id: 'tw.accent.custom'
  }
});

const icons = {
  [ACCENT_RAINBOW]: rainbowIcon
};
const ColorIcon = (props) =>
  icons[props.id] ? (
    <img
      className={styles.accentIconOuter}
      src={icons[props.id]}
      draggable={false}
      // Image is decorative
      alt=""
    />
  ) : props.id != 'custom' ? (
    <div
      className={styles.accentIconOuter}
      style={{
        // menu-bar-background is var(...), don't want to evaluate with the current values
        backgroundColor: ACCENT_MAP[props.id].guiColors['looks-secondary'],
        backgroundImage: ACCENT_MAP[props.id].guiColors['menu-bar-background-image']
      }}
    />
  ) : (
    <img className={styles.accentIconOuter} src={customIcon} draggable={false} alt="" />
  );

ColorIcon.propTypes = {
  id: PropTypes.string
};

const AccentMenuItem = (props) => (
  <MenuItem onClick={props.onClick}>
    <div className={styles.option}>
      <img
        className={classNames(styles.check, { [styles.selected]: props.isSelected })}
        width={15}
        height={12}
        src={check}
        draggable={false}
      />
      <ColorIcon id={props.id} />
      <FormattedMessage {...options[props.id]} />
    </div>
  </MenuItem>
);

AccentMenuItem.propTypes = {
  id: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func
};

const AccentThemeMenu = ({ isOpen, isRtl, onChangeTheme, onOpen, onClickCustomThemeModal, theme }) => (
  <MenuItem expanded={isOpen}>
    <div className={styles.option} onClick={onOpen}>
      <ColorIcon id={theme.accent} />
      <span className={styles.submenuLabel}>
        <FormattedMessage
          defaultMessage="Accent"
          description="Label for menu to choose accent color (eg. TurboWarp's red, Scratch's purple)"
          id="tw.menuBar.accent"
        />
      </span>
      <img className={styles.expandCaret} src={dropdownCaret} draggable={false} />
    </div>
    <Submenu place={isRtl ? 'left' : 'right'}>
      {Object.keys(options).map((item) => (
        <AccentMenuItem
          key={item}
          id={item}
          isSelected={theme.accent === item}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => {
            if (item == 'custom') onClickCustomThemeModal();
            else onChangeTheme(theme.set('accent', item));
          }}
        />
      ))}
    </Submenu>
  </MenuItem>
);

AccentThemeMenu.propTypes = {
  isOpen: PropTypes.bool,
  isRtl: PropTypes.bool,
  onChangeTheme: PropTypes.func,
  onClickCustomThemeModal: PropTypes.func,
  onOpen: PropTypes.func,
  theme: PropTypes.instanceOf(Theme)
};

const mapStateToProps = (state) => ({
  isOpen: accentMenuOpen(state),
  isRtl: state.locales.isRtl,
  theme: state.scratchGui.theme.theme
});

const mapDispatchToProps = (dispatch) => ({
  onChangeTheme: (theme) => {
    dispatch(setTheme(theme));
    dispatch(closeSettingsMenu());
    persistTheme(theme);
  },
  onOpen: () => dispatch(openAccentMenu()),
  onClickCustomThemeModal: () => {
    dispatch(closeEditMenu());
    dispatch(openCustomTheme());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AccentThemeMenu);
